<template>
  <div>
    <md-dialog :md-active.sync="show" @md-clicked-outside="closeDialog" @md-closed="closeDialog">
      <md-dialog-title>Import Hardware OTP</md-dialog-title>
      <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-field>
          <label>OTP CSV File</label>
          <md-file v-model="selectedFile" accept=".csv" name="file" @change="handleFileUpload($event)"></md-file>
          <span class="md-error">OTP CSV file is required.</span>
        </md-field>
        <div class="md-layout-item md-size-100 text-right">
          <md-button @click="closeDialog">Cancel</md-button>
          <md-button class="md-primary" :disabled="!parsed" @click="parseFile">Next</md-button>
        </div>
      </div>
    </md-dialog>
    <md-dialog :md-active.sync="showPreview" @md-closed="showPreview = false">
      <md-dialog-title>CSV File Preview</md-dialog-title>
      <div class="md-dialog-content md-layout-item md-small-size-100 md-small-size-100">
        <div class="md-layout">
          <md-table
            class="md-layout-item md-small-size-100 md-small-size-100"
            v-if="parsed"
            table-header-color="purple"
          >
            <template>
              <md-table-row>
                <md-table-head> Serial number </md-table-head>
                <md-table-head> Seed </md-table-head>
                <md-table-head> Time Step </md-table-head>
              </md-table-row>
              <md-table-row v-for="(_, rowKey) in content.data" :key="'row-' + rowKey">
                <md-table-cell
                  v-for="(_, columnKey) in content.data[rowKey]"
                  :key="'row-' + rowKey + '-column-' + columnKey"
                >
                  <span>{{ content.data[rowKey][columnKey] }}</span>
                </md-table-cell>
              </md-table-row>
            </template>
          </md-table>
          <div class="md-layout-item md-size-100 text-right">
            <md-button @click="showPreview = false">Cancel</md-button>
            <md-button class="md-primary" @click="insertCsv">Upload</md-button>
          </div>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import Papa from "papaparse";
import { ref } from "@vue/composition-api";
import NotificationStore from "../../components/NotificationPlugin/NotificationStore";
import store from "../../store";
export default {
  name: "ImportOtpWithCsv",
  props: ["show"],
  setup: (props, { emit }) => {
    const closeDialog = () => {
      selectedFile.value = "";
      parsed.value = false;
      emit("refreshTable");
      emit("close");
    };

    const file = ref("");
    const content = ref([]);
    const parsed = ref(false);
    const showPreview = ref(false);
    const selectedFile = ref("");
    const handleFileUpload = (event) => {
      file.value = event.target.files[0];
      parseFile();
    };
    const parseFile = () => {
      Papa.parse(file.value, {
        header: false,
        skipEmptyLines: true,
        complete: function (results) {
          content.value = results;
          parsed.value = true;
          showPreview.value = true;
        }.bind(this),
      });
    };

    const insertCsv = async () => {
      const data = new FormData();
      data.append("csv_file", file.value);
      data.append("type", "hardware_totp");

      const url = store.getters.getServerAddress + "api/v1/dashboard/add-hardware-device/";
      const headers = {
        Authorization: this.$store.getters.getAccessToken
      };
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: data,
      });
      if (response.status === 200) {
        NotificationStore.notify({
          message: "Hardware OTPs uploaded successfully.",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        showPreview.value = false;

        closeDialog();
      } else {
        NotificationStore.notify({
          message: (await response.json()).message_detail,
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        showPreview.value = false;
      }
    };

    return {
      closeDialog,
      handleFileUpload,
      parsed,
      content,
      showPreview,
      file,
      parseFile,
      selectedFile,
      insertCsv,
    };
  },
};
</script>
